import { render, staticRenderFns } from "./SettingsCustomerDefaultGroup.vue?vue&type=template&id=d1255564&"
import script from "./SettingsCustomerDefaultGroup.vue?vue&type=script&lang=ts&"
export * from "./SettingsCustomerDefaultGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports